import React from 'react'
import classNames from 'classnames'
import classes from './Spinner.module.css'

export default function Spinner({ className, ...props }) {
    return <div className={classNames(classes.spinner, className)} {...props} />
}
